<template>
    <page-title
        title="ログイン"
    >
    </page-title>

    <form class="form" @submit.prevent="signin()">
        <div class="form-row align-items-end mb-3">
            <div class="form-group col-md-6">
                <label>ログインID</label>
                <input type="text" class="form-control" required="required" v-model="user_login">
            </div>
        </div>
        <div class="form-row align-items-end mb-3">
            <div class="form-group col-md-6">
                <label>パスワード</label>
                <div class="position-relative">
                    <input :type="password_visible ? 'text' : 'password'" class="form-control" required="required" v-model="password">
                    <i
                        class="bi translate-middle position-absolute top-50 end-0"
                        :class="password_visible ? 'bi-eye-slash' : 'bi-eye'"
                        style="cursor: pointer"
                        v-on:click="togglePasswordVisibilityIcon"
                    ></i>
                </div>
            </div>
        </div>
        <div class="form-row">
            <button-exec-edit text="ログイン" />
        </div>
    </form>
</template>

<script>
import axios from 'axios';
import ButtonExecEdit from '@/shared/components/design/buttons/ButtonExecEdit.vue';
import PageTitle from '@/shared/components/design/PageTitle.vue';

export default {
    components: {
        ButtonExecEdit,
        PageTitle,
    },
    name: 'PageSignin',
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showErrorMessage',
    ],
    data() {
        return {
            user_login: null,
            password: null,
            password_visible: false,
        }
    },
    methods: {
        signin() {
            this.startScreenLoading();
            axios.post(process.env.VUE_APP_BASE_URI + '/distributor/signin', {
                user_login: this.user_login,
                password: this.password
            })
            .then((response) => {
                //非同期なので、action を dispatch しなければいけないはずだが、
                //なぜかエラーは出ない
                this.$store.commit('distributor/auth/setAccessToken', {
                    distributor_name: response.data.distributor_name,
                    distributor_user_name: response.data.distributor_user_name,
                    access_token: response.data.access_token,
                    access_token_expired: response.data.access_token_expired,
                    access_token_issued: response.data.access_token_issued,
                    refresh_token: response.data.refresh_token,
                    refresh_token_expired: response.data.refresh_token_expired,
                    refresh_token_issued: response.data.refresh_token_issued,
                });

                //後で消すかも
                //this.showMessage('ログイン成功', 'ようこそ' + response.data.distributor_user_name + 'さん');

                if (this.$route.query.redirect) {
                    this.$router.push(this.$route.query.redirect);
                } else {
                    this.$router.push('/distributor');
                }
            })
            .catch((error) => {
                //※ここは $http 使っていないので、自力でメッセージ表示が必要
                this.showErrorMessage(error.response.data.message);
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        togglePasswordVisibilityIcon() {
          this.password_visible = !this.password_visible;
        }
    }
}
</script>

<style scoped>

</style>
